var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"variant-selector"},[_c('ul',_vm._l((_vm.products),function(product){return _c('li',{key:product.id,class:[
        _vm.selectedProductId === product.id ? 'selected' : '',
        'variant-selector__item' ],on:{"click":function($event){return _vm.$emit('select-variant', product.id)}}},[_c('span',[_vm._v(" "+_vm._s(product.tagName)+" ")])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }